import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";

export const useQuestionsReorder = (groupId?: string) => {

    const axios = useAxios();
    const {t} = useTranslation();
    const queryClient = useQueryClient();
    const {message} = App.useApp();

    const reorder = async (examGroup: any) => {
        let data = {
            groupId: groupId,
            questionsOrder: examGroup.map((q: any, index: number) => {
                return {QuestionId: q.id, OrderNumber: index}
            })
        }

        try {
            const response = await axios.put(`/api/examgroup/ReorderQuestions`, data);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.examGroupReorder"));
        }
    }

    return useMutation({mutationFn: reorder, 
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["examGroupQuestions", groupId]});
            message.success(t("messages.success.examGroupQuestionReorder"));
        }
    });
}